import { useCallbackRef } from '@talos/kyoko';
import { useEffect, useState } from 'react';
import { useIsMobileLayout } from '../../hooks';

/**
 * Local UL Symbols visibility.
 * Desktop seeds from Unified Liquidity and reseeds when UL or `resetKey` (symbol) changes.
 * Mobile stays off until the user opts in, ignores UL on/off, and resets to off when `resetKey` changes.
 */
export function useULSymbolsVisibility(ulEnabled: boolean, resetKey?: string) {
  const isMobileLayout = useIsMobileLayout();
  const [ulSymbolsVisible, setUlSymbolsVisible] = useState(() => !isMobileLayout && ulEnabled);

  useEffect(() => {
    if (!isMobileLayout) {
      setUlSymbolsVisible(ulEnabled);
    }
  }, [isMobileLayout, resetKey, ulEnabled]);

  useEffect(() => {
    if (isMobileLayout) {
      setUlSymbolsVisible(false);
    }
  }, [isMobileLayout, resetKey]);

  const syncFromUnifiedLiquidity = useCallbackRef((enabled: boolean) => {
    if (!isMobileLayout) {
      setUlSymbolsVisible(enabled);
    }
  });

  return [ulSymbolsVisible, setUlSymbolsVisible, syncFromUnifiedLiquidity] as const;
}
